import { render } from "./printModal.vue?vue&type=template&id=bcf5bc22"
import script from "./printModal.vue?vue&type=script&lang=js"
export * from "./printModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__